var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticClass:"mt-md-15",staticStyle:{"margin-bottom":"200px"}},[_c('v-card-title',[_vm._v(" Administración "),_c('v-spacer'),_c('v-btn',{on:{"click":_vm.logout}},[_vm._v(" Salir ")])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }